module.exports = __webpack_public_path__ + "media/dashboard.022e333b.mp4";